<template lang="html">
    <div class="iconsCell">
        <!-- Warning - Notes -->
        <div v-if="hasNotes" v-tooltip="'Has Notes'" class="text-center"><i class="ico ico-alert color-6 mr-0 fs-largest"></i></div>
        <div v-else></div>

        <!-- Transport -->
        <div v-if="hasTransport" v-tooltip="'Has transport'" class="text-center"><i class="ico ico-vehicle mr-0 fs-largest"></i></div>
        <div v-else></div>

        <!-- Reservation Canceled -->
        <div v-if="isReservationCanceled" v-tooltip="'Reservation Canceled'" class="text-center"><i class="ico ico-canceled medium mr-0 fs-largest"></i></div>

        <!-- Checkin - All pax checked in -->
        <div v-else-if="allPaxCheckedIn" v-tooltip="'All Pax Checked'" class="text-center"><i class="ico ico-check color-3 mr-0 fs-largest"></i></div>

        <!-- Checkin - Pax missing -->
        <div v-else-if="checkInPaxMissing" v-tooltip="'Pax missing checkin'" class="text-center"><i class="ico ico-check color-4 mr-0 fs-largest"></i></div>

        <div v-else></div>
    </div>
</template>

<script>
export default {
    props: {
        arguments:{
            required: true
        }
    },
    computed:{
        reservation: function () {
            return this.arguments
        },
        hasTransport: function () {
            return this.reservation.hasTransport
        },
        hasNotes: function () {
            return this.reservation.note && this.reservation.note.length > 0
        },
        isReservationCanceled: function() {
            return this.reservation.status == -5
        },
        allPaxCheckedIn: function () {
            return this.reservation.paxCheckedIn == this.reservation.paxTotal
        },
        checkInPaxMissing: function () {
            return this.reservation.paxCheckedIn + this.reservation.paxNoShow == this.reservation.paxTotal && !this.allPaxCheckedIn
        }
    }
}
</script>

<style lang="scss" scoped>

.iconsCell{
    display: grid;
    grid-gap: 5px;
    /* Space between items */
    // grid-template-columns: 1fr 1fr 1fr;
    grid-auto-flow: column;
    grid-auto-columns: 1fr 1fr 1fr;
    /* Decide the number of columns and size */
    // margin: auto;
    // grid-template-columns: min-content 1fr
}

</style>



// WEBPACK FOOTER //
// icons.vue?35e222b0